import { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReplyWdw,
  fetchStickerLounges,
  likeCommentReply,
} from '../redux/lounges/slice';
import stickerImage from '../assets/img/stickers.jpg';
import { StickerTabs } from '../components/StickerTabs';

import imageicon from '../assets/img/chart-icon1.png';
import emojiicon from '../assets/img/chart-icon2.png';
import { RichTextEditor } from '@mantine/rte';
import imageiconh from '../assets/img/chart-icon1h.png';
import emojiiconh from '../assets/img/chart-icon2h.png';
import { EditBox } from '../components/EditBox';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeUserLounge } from '../redux/lounges/slice';
import { LikeCommentReply } from '../components/LikeCommentReply';
import { GET_BASE_URL_IMAGE, dTime } from '../constants/apiEndpoints';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import axios, { AxiosResponse } from 'axios';
import  { CommentReplyBox } from './WdwCommentReplyBox';
import { insertCommentMention } from '../utils/commentMentionInsert';
import { insertStickerIntoRichTextEditor } from '../utils/richTextStickerInsert';

type CommentReplyPropsType = {
  replyData: any;
  replyShow: boolean;
  chatId: any;
  chat_reply_id: any;
  stickerData: any;
  parentCommentUserName?: string;
  parentCommentText?: string;
  replyTargetUserName?: string;
  replyTargetReplyId?: any;
  replyTargetText?: string;
  onCancelReply?: () => void;
  onRequestReply?: (
    targetUserName?: string,
    targetReplyId?: any,
    targetReplyText?: string
  ) => void;
  onReplySubmitted?: () => void;
};
type FormData = {
  chat_reply_msg: string;
  chat_id: number;
  chat_reply_id: number;
};

export const CommentReply: React.FC<CommentReplyPropsType> = ({
  replyData,
  replyShow,
  chatId,
  chat_reply_id,
  stickerData,
  parentCommentUserName,
  parentCommentText,
  replyTargetUserName,
  replyTargetReplyId,
  replyTargetText,
  onCancelReply,
  onRequestReply,
  onReplySubmitted,
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm<FormData>();
  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const [commentData, SetCommentData] = useState<any | []>(replyData);
  const [showSticker, SetShowSticker] = useState<any | string>(false);
  const token = localStorage.getItem('token');
  const loginuserid = localStorage.getItem('user_id');

  const textRef = useRef(null);
  const replyTargetName =
    replyTargetUserName || parentCommentUserName || 'this comment';
  const parentPreview = (replyTargetText || parentCommentText || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 140);
  const [ filterUser, setFilterUser ] = useState<any[]>([]);
  const [ searchText, setSearchText ] = useState('');
  const selectedMentionRef = useRef('');

  const onClickSticker = (data: any) => {
    insertStickerIntoRichTextEditor(textRef, data, text, setText);
  }

  const onSubmit = () => {
    const chat_reply_msg = getValues('chat_reply_msg');
    const existingReplyIds = new Set<string>(
      (commentData || [])
        .map((rep: any) => getReplyPlacementId(rep))
        .filter((id: any) => id != null)
        .map((id: any) => String(id))
    );

    chat_reply_msg != '' && chat_reply_msg != '<p><br></p>'
      ? dispatch<any>(
          postLoungeCommentReplyWdw({
            chat_reply_msg,
            chat_id: chatId,
            chat_reply_id,
            parent_reply_id: replyTargetReplyId ?? null,
          } as any)
        ).then((res: any) => {
          reset();
          SetCommentData(orderRepliesForDisplay(res.payload.data.replydata, existingReplyIds));
          setText('');
          SetShowSticker(false);
          onReplySubmitted?.();
          // dispatch(fetchLoungeDetails({ LoungeId }))
        })
      : alert('Please enter reply');
  };

  function converTime(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }


  const modules = {
    toolbar: false,
  };
  /*   useEffect(() => {
    register('chat_reply_msg', { required: true, minLength: 11 });
  }, [register]);

  const onEditorStateChange = (editorState: any) => {
    setValue('chat_reply_msg', editorState);
  }; */

  const [text, setText] = useState('');

  useEffect(() => {
    setValue('chat_reply_msg', text);
    if(text == '' || text == '<p><br></p>') 
      setFilterUser([]);
  }, [setValue, text]);


  const openSticker = () => {
    SetShowSticker(!showSticker);
  };
  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }
  const [Notify, setIsNotify] = useState<any | string>();
  const [RemoveType, setRemoveType] = useState<any | string>('R');

  const [editbox, SetEditBox] = useState<any | string>(false);
  const showEditBox = () => {
    SetEditBox(!editbox);
  };

  /* const likeCommnetAndReply = (
    chat_id: any,
    comment_id: any,
    reply_id: any,
    commnet_userid: any,
    type: any,
    page: any
  ) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      console.log('like');

      dispatch<any>(
        likeCommentReply({
          chat_id,
          comment_id,
          reply_id,
          commnet_userid,
          type,
          page,
        })
      ).then((res: any) => {
        window.location.reload();
        Notify(toast(res.payload.data.error));
      });
    }
  }; */

  const mentions = useMemo(
    () => ({
      allowedChars: /^[A-Za-z0-9_\-\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      source: (
        searchTerm: any,
        renderList: any,
        mentionChar: any,
        _callback: any
      ) => {
        setSearchText(searchTerm);
        const normalizedSearchTerm = String(searchTerm ?? '').toLowerCase();

        if (
          selectedMentionRef.current &&
          normalizedSearchTerm === selectedMentionRef.current
        ) {
          selectedMentionRef.current = '';
          setFilterUser([]);
          renderList([]);
          return;
        }

        if (mentionChar !== '@' || searchTerm.length === 0) {
          setFilterUser([]);
          renderList([]);
        } else {
          axios
            .get(GET_BASE_URL + '/api/v1/getUser?name=' + searchTerm)
            .then((response: any) => {
              const includesSearchTerm = response.data.data.filter(
                (item: any) =>
                  item.value.toLowerCase().includes(searchTerm.toLowerCase())
              );

              setFilterUser(includesSearchTerm);
              renderList([]);
            });
        }
      },
    }),
    []
  );

  const onChangeFilterUser = (item: any) => {
    const username = String(item?.value ?? '').replace(/^@/, '').trim();
    const normalizedUsername = username.toLowerCase();

    if (normalizedUsername) {
      selectedMentionRef.current = normalizedUsername;
      window.setTimeout(() => {
        if (selectedMentionRef.current === normalizedUsername) {
          selectedMentionRef.current = '';
        }
      }, 1000);
    }

    const nextText = insertCommentMention({
      editor: (textRef.current as any)?.getEditor?.(),
      currentText: text,
      searchText,
      username,
    });

    setText(nextText);
    setValue('chat_reply_msg', nextText);
    setSearchText('');
    setFilterUser([]);
  }

  const getReplyPlacementId = (rep: any) =>
    rep?.id ?? rep?.reply_id ?? rep?.chat_reply_reply_id;

  const getReplyParentId = (rep: any) =>
    rep?.parent_reply_id ?? rep?.reply_parent_id ?? rep?.reply_target_reply_id;

  const isActiveReplyTarget = (rep: any) =>
    replyTargetReplyId != null &&
    String(replyTargetReplyId) === String(getReplyPlacementId(rep));

  const getReplyKey = (rep: any, fallback: number) =>
    String(getReplyPlacementId(rep) ?? `${rep?.chat_reply_id ?? 'reply'}-${fallback}`);

  const orderRepliesForDisplay = (
    replies: any[] = [],
    existingReplyIds: Set<string>
  ) => {
    if (!Array.isArray(replies)) {
      return replies;
    }

    const normalizedReplies = replies.map((rep: any) => {
      const placementId = getReplyPlacementId(rep);
      const parentId = getReplyParentId(rep);

      if (
        replyTargetReplyId != null &&
        placementId != null &&
        parentId == null &&
        !existingReplyIds.has(String(placementId))
      ) {
        return { ...rep, parent_reply_id: replyTargetReplyId };
      }

      return rep;
    });

    const repliesById = new Map<string, any>();
    normalizedReplies.forEach((rep: any) => {
      const placementId = getReplyPlacementId(rep);
      if (placementId != null) {
        repliesById.set(String(placementId), rep);
      }
    });

    const orderedReplies: any[] = [];
    const seenReplyIds = new Set<string>();

    const appendReplyWithChildren = (rep: any) => {
      const placementId = getReplyPlacementId(rep);
      const placementKey = placementId != null ? String(placementId) : null;

      if (placementKey && seenReplyIds.has(placementKey)) {
        return;
      }

      if (placementKey) {
        seenReplyIds.add(placementKey);
      }
      orderedReplies.push(rep);

      normalizedReplies.forEach((candidate: any) => {
        const parentId = getReplyParentId(candidate);
        if (placementKey && parentId != null && String(parentId) === placementKey) {
          appendReplyWithChildren(candidate);
        }
      });
    };

    normalizedReplies.forEach((rep: any) => {
      const parentId = getReplyParentId(rep);
      if (parentId == null || !repliesById.has(String(parentId))) {
        appendReplyWithChildren(rep);
      }
    });

    normalizedReplies.forEach(appendReplyWithChildren);

    return orderedReplies;
  };

  const renderReplyComposer = () => (
    <div className='mw-inline-reply'>
      <div className='mw-inline-reply-context'>
        <div className='mw-inline-reply-copy'>
          <span className='mw-inline-reply-kicker'>Replying publicly to comment</span>
          <strong>{replyTargetName}</strong>
          <span>This posts publicly under this Lounge comment.</span>
        </div>
        {onCancelReply && (
          <button type='button' onClick={onCancelReply}>
            Cancel
          </button>
        )}
      </div>
      {parentPreview && (
        <div className='mw-inline-reply-preview'>{parentPreview}</div>
      )}
      <form
        className='space-y-6'
        onSubmit={handleSubmit(onSubmit)}
        method='POST'
      >
        <div className='com-box-main' style={{'position': 'relative'}}>
          {filterUser.length > 0 && (
          <div className="tagUserList mw-mention-picker" role="listbox" aria-label="Tag a MouseWait user">
            {
              filterUser.map((item, index) => {
                return (
                  <div className="tagUserItem" key={item?.id ?? item?.value ?? index}>
                    <button
                      type="button"
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => onChangeFilterUser(item)}
                      className="button"
                    >
                      <div>
                        <img
                          style={{ verticalAlign: 'middle' }}
                          src={
                            GET_BASE_URL_IMAGE +
                            '/disneyland/images/thumbs/' +
                            item['image']
                          }
                          className='com-imggg'
                          alt=""
                        />
                      </div>

                      <div>
                        @{item['value']}
                      </div>
                    </button>
                  </div>
                )
              })
            }
            </div>
          )}

          <div className='com-box d-flex'>
            <RichTextEditor
              id='rte'
              placeholder={`Reply to ${replyTargetName}...`}
              mentions={mentions}
              value={text}
              onChange={setText}
              controls={[[]]}
              ref={textRef}
            />

            <input
              type='hidden'
              readOnly={true}
              {...register('chat_id')}
              defaultValue={chatId}
            />
            <input
              type='hidden'
              readOnly={true}
              {...register('chat_reply_id')}
              defaultValue={chat_reply_id}
            />

            <div className='icon-ic d-flex'>
              <div className='icon-ic0' onClick={handleSubmit(onSubmit)}>
              </div>
              <div className='icon-ic1' onClick={openSticker}>
              </div>
            </div>
          </div>
        </div>
      </form>
      {showSticker == true && (
        <div className='mw-sticker-popover-wrap'>
          <button
            type='button'
            className='mw-sticker-popover-close'
            aria-label='Close sticker picker'
            onClick={() => SetShowSticker(false)}
          >
            ×
          </button>
          <StickerTabs
            tabData={stickerData}
            onClickSticker={onClickSticker}
            onStickerInserted={() => SetShowSticker(false)}
          />
        </div>
      )}{' '}
    </div>
  );

  return (
    <>
      {replyShow == true && replyTargetReplyId == null && renderReplyComposer()}
      {orderRepliesForDisplay(commentData, new Set<string>()).map((rep: any, index2: any) => (

        <CommentReplyBox
          replyData={rep}
          key={getReplyKey(rep, index2)}
          stickerData={stickerData}
          onReplyToParent={onRequestReply}
          replyComposer={
            replyShow == true && isActiveReplyTarget(rep)
              ? renderReplyComposer()
              : null
          }
        ></CommentReplyBox>
      ))}
    </>
  );
};
